import { render, staticRenderFns } from "./CountryConfig.vue?vue&type=template&id=07bb048a&scoped=true"
import script from "./CountryConfig.vue?vue&type=script&lang=js"
export * from "./CountryConfig.vue?vue&type=script&lang=js"
import style0 from "./CountryConfig.vue?vue&type=style&index=0&id=07bb048a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bb048a",
  null
  
)

export default component.exports